import { render, staticRenderFns } from "./work-packages-unit-kpi-icon.vue?vue&type=template&id=54d2fbb4&scoped=true"
import script from "./work-packages-unit-kpi-icon.vue?vue&type=script&lang=js"
export * from "./work-packages-unit-kpi-icon.vue?vue&type=script&lang=js"
import style0 from "./work-packages-unit-kpi-icon.vue?vue&type=style&index=0&id=54d2fbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2fbb4",
  null
  
)

export default component.exports